module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Twin Behind the Curtain")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#prologue"
    }
  }, [_vm._v("Prologue")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#appleton-wisconsin"
    }
  }, [_vm._v("1. Appleton, Wisconsin")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#budapest-hungary"
    }
  }, [_vm._v("2. Budapest, Hungary")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#bratislava-czechoslovakia"
    }
  }, [_vm._v("3. Bratislava, Czechoslovakia")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#vienna-austria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Vienna, Austria")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#washington-d.c.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Washington, D.C.")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#long-beach-california",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Long Beach, California")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#prague-czechoslovakia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Prague, Czechoslovakia")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#wolkenstein-east-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Wolkenstein, East Germany")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#karl-marx-stadt-east-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Karl Marx Stadt, East Germany")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#east-berlin-east-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. East Berlin, East Germany")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#leipzig-east-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Leipzig, East Germany")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#dresden-east-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Dresden, East Germany")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#warsaw-poland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Warsaw, Poland")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#long-beach-california-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Long Beach, California")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#appleton-wisconsin-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Appleton, Wisconsin")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0